export default {
  'ssr.title.batch.input.queue': {
    ko: 'Batch-input queue',
    ja: 'バッチ入力キュー',
    en: 'Batch-input queue',
  },
  'ssr.title.roll.in': {
    ko: 'Roll ins',
    ja: 'ロールイン',
    en: 'Roll ins',
  },
  'ssr.title.term.in.msg': {
    ko: 'Terminal In-message',
    ja: 'ターミナルインメッセージ',
    en: 'Terminal In-message',
  },
  'ssr.title.no.conn': {
    ko: 'Number Connections',
    ja: '接続数',
    en: 'Number Connections',
  },
  'ssr.title.ip.addr': {
    ko: 'IP address',
    ja: 'IPアドレス',
    en: 'IP address',
  },
  'ssr.title.logon.method': {
    ko: 'Logon method',
    ja: 'ログオン方法',
    en: 'Logon method',
  },
  'ssr.title.wp.restart': {
    ko: 'Workprocess restarted',
    ja: 'ワークプロセス再開',
    en: 'Workprocess restarted',
  },
  'ssr.title.prev.cmpnt.nm': {
    ko: "Previous Component's name",
    ja: '前のコンポーネント名',
    en: "Previous Component's name",
  },
  'ssr.title.calling.time': {
    ko: 'Calling time',
    ja: 'コールタイム',
    en: 'Calling time',
  },
  'ssr.title.dstns': {
    ko: 'Destinations',
    ja: '宛先',
    en: 'Destinations',
  },
  'ssr.title.conn': {
    ko: 'Connection',
    ja: '接続',
    en: 'Connection',
  },
  'ssr.title.enq': {
    ko: 'Enqueues',
    ja: 'エンキュー',
    en: 'Enqueues',
  },
  'ssr.title.users': {
    ko: 'Users',
    ja: 'ユーザー',
    en: 'Users',
  },
  'ssr.title.remote.exec': {
    ko: 'Remote execution',
    ja: 'リモート実行',
    en: 'Remote execution',
  },
  'ssr.title.logon.time': {
    ko: 'Logon time',
    ja: 'ログオン時間',
    en: 'Logon time',
  },
  'ssr.title.max.mem': {
    ko: 'Max. memory used in roll areas',
    ja: 'ロールエリアで使用された最大メモリ',
    en: 'Max. memory used in roll areas',
  },
  'ssr.title.rfc.ptnr.engn': {
    ko: 'RFC Partner Engine',
    ja: 'RFCパートナーエンジン',
    en: 'RFC Partner Engine',
  },
  'ssr.title.req.time': {
    ko: 'Request time',
    ja: 'リクエスト時間',
    en: 'Request time',
  },
  'ssr.title.rfc.type': {
    ko: 'RFC Type',
    ja: 'RFCタイプ',
    en: 'RFC Type',
  },
  'ssr.title.avg.time': {
    ko: 'Avg. time / row (ms)',
    ja: '平均時間/行(ms)',
    en: 'Avg. time / row (ms)',
  },
  'ssr.title.task.type': {
    ko: 'Task type',
    ja: 'タスクタイプ',
    en: 'Task type',
  },
  'ssr.title.tot.time': {
    ko: 'Total time in workprocs',
    ja: 'ワークプロセスの合計時間',
    en: 'Total time in workprocs',
  },
  'ssr.title.in.trxn': {
    ko: 'In transaction',
    ja: 'トランザクション中',
    en: 'In transaction',
  },
  'ssr.title.rfc.engn': {
    ko: 'RFC Engine',
    ja: 'RFCエンジン',
    en: 'RFC Engine',
  },
  'ssr.title.caller.clnt.no': {
    ko: 'Caller client number',
    ja: 'コーラーのクライアント番号',
    en: 'Caller client number',
  },
  'ssr.title.inst': {
    ko: 'Instance',
    ja: 'インスタンス',
    en: 'Instance',
  },
  'ssr.title.conn.counter': {
    ko: 'Connection Couter',
    ja: '接続カウンター',
    en: 'Connection Counter',
  },
  'ssr.title.dstn': {
    ko: 'Destination',
    ja: '宛先',
    en: 'Destination',
  },
  'ssr.title.idle': {
    ko: 'Idle',
    ja: 'アイドル',
    en: 'Idle',
  },
  'ssr.title.clnt.conn.rec': {
    ko: 'Client Connection Record',
    ja: 'クライアント接続レコード',
    en: 'Client Connection Record',
  },
  'ssr.title.gen.time': {
    ko: 'Generating time',
    ja: '生成時間',
    en: 'Generating time',
  },
  'ssr.title.db.req.time': {
    ko: 'DB request time',
    ja: 'DBリクエスト時間',
    en: 'DB request time',
  },
  'ssr.title.enq.time': {
    ko: 'Enqueue time',
    ja: 'エンキュー時間',
    en: 'Enqueue time',
  },
  'ssr.title.type.req': {
    ko: 'Type of ABAP request',
    ja: 'ABAPリクエストのタイプ',
    en: 'Type of ABAP request',
  },
  'ssr.title.wp.no': {
    ko: 'Work process no',
    ja: 'ワークプロセス番号',
    en: 'Work process no',
  },
  'ssr.title.sscr': {
    ko: 'Server Single Call Record',
    ja: 'サーバーのシングルコールレコード',
    en: 'Server Single Call Record',
  },
  'ssr.title.db.rows': {
    ko: 'Database rows',
    ja: 'データベースの行',
    en: 'Database rows',
  },
  'ssr.title.net.time': {
    ko: 'Net time',
    ja: 'ネットタイム',
    en: 'Net time',
  },
  'ssr.title.req.buf': {
    ko: 'Requests to buffer',
    ja: 'バッファへのリクエスト',
    en: 'Requests to buffer',
  },
  'ssr.title.cscr': {
    ko: 'Client Single Call Record',
    ja: 'クライアントのシングルコールレコード',
    en: 'Client Single Call Record',
  },
  'ssr.title.sssn.id': {
    ko: 'Session-ID',
    ja: 'セッションID',
    en: 'Session-ID',
  },
  'ssr.title.ddic.interf.time': {
    ko: 'DDIC interface time',
    ja: 'DDICインターフェイス時間',
    en: 'DDIC interface time',
  },
  'ssr.title.as.clnt': {
    ko: 'as Client',
    ja: 'クライアントとして',
    en: 'as Client',
  },
  'ssr.title.wp.priv.mode': {
    ko: 'Workprocess in PIRV mode',
    ja: 'PIRVモードでのワークプロセス',
    en: 'Workprocess in PIRV mode',
  },
  'ssr.title.rfc.interf.time': {
    ko: 'RFC interface time',
    ja: 'RFCインターフェイス時間',
    en: 'RFC interface time',
  },
  'ssr.title.clnt': {
    ko: 'Client',
    ja: 'クライアント',
    en: 'Client',
  },
  'ssr.title.ptnr.ip.addr': {
    ko: 'Partner IP address',
    ja: 'パートナーIPアドレス',
    en: 'Partner IP address',
  },
  'ssr.title.cpu.time': {
    ko: 'CPU time',
    ja: 'CPU時間',
    en: 'CPU time',
  },
  'ssr.title.total': {
    ko: 'Total',
    ja: '合計',
    en: 'Total',
  },
  'ssr.title.ini.svc.type': {
    ko: 'Initial service type',
    ja: 'イニシャルサービスタイプ',
    en: 'Initial service type',
  },
  'ssr.title.svr.conn.rec': {
    ko: 'Server Connection Record',
    ja: 'サーバー接続レコード',
    en: 'Server Connection Record',
  },
  'ssr.title.sent.data': {
    ko: 'Sent data',
    ja: '送信したデータ',
    en: 'Sent data',
  },
  'ssr.title.local.exec.time': {
    ko: 'Local exec. time',
    ja: 'ローカル実行時間',
    en: 'Local exec. time',
  },
  'ssr.title.req': {
    ko: 'Request',
    ja: 'リクエスト',
    en: 'Request',
  },
  'ssr.title.roll.all.time': {
    ko: 'Roll (in+wait) time',
    ja: 'ロール(イン+待機)時間',
    en: 'Roll (in+wait) time',
  },
  'ssr.title.time.calling': {
    ko: 'Time calling',
    ja: 'コール時間',
    en: 'Time calling',
  },
  'ssr.title.db.proc.call': {
    ko: 'DB Proc. Calls',
    ja: 'DB Proc. コール',
    en: 'DB Proc. Calls',
  },
  'ssr.title.term.out.msg': {
    ko: 'Terminal Out-message',
    ja: 'ターミナルアウトメッセージ',
    en: 'Terminal Out-message',
  },
  'ssr.title.out': {
    ko: 'Out',
    ja: 'アウト',
    en: 'Out',
  },
  'ssr.title.reqs': {
    ko: 'Requests',
    ja: 'リクエスト',
    en: 'Requests',
  },
  'ssr.title.ptnr.inst': {
    ko: 'Partner instance',
    ja: 'パートナーインスタンス',
    en: 'Partner instance',
  },
  'ssr.title.received': {
    ko: 'Received',
    ja: '受信済み',
    en: 'Received',
  },
  'ssr.title.time.ms': {
    ko: 'time (ms)',
    ja: '時間(ms)',
    en: 'time (ms)',
  },
  'ssr.title.as.svr': {
    ko: 'as Server',
    ja: 'サーバーとして',
    en: 'as Server',
  },
  'ssr.title.number': {
    ko: 'Number',
    ja: '番号',
    en: 'Number',
  },
  'ssr.title.diag.step': {
    ko: 'Dialog-step',
    ja: 'ダイアログステップ',
    en: 'Dialog-step',
  },
  'ssr.title.ini.act.type': {
    ko: 'Initial action type',
    ja: 'イニシャルアクションタイプ',
    en: 'Initial action type',
  },
  'ssr.title.data.send.time': {
    ko: 'Data send time',
    ja: 'データ送信時間',
    en: 'Data send time',
  },
  'ssr.title.gui.time': {
    ko: 'GUI time',
    ja: 'GUI時間',
    en: 'GUI time',
  },
  'ssr.title.ini.act': {
    ko: 'Initial action',
    ja: 'イニシャルアクション',
    en: 'Initial action',
  },
  'ssr.title.ini.user.id': {
    ko: 'Initial user-ID',
    ja: 'イニシャルユーザーID',
    en: 'Initial user-ID',
  },
  'ssr.title.ctxt.menu': {
    ko: 'View SSR details',
    ja: 'View SSR details',
    en: 'View SSR details',
  },
  'ssr.title.db.req.total': {
    ko: 'Database request total',
    ja: 'データベースリクエストの合計',
    en: 'Database request total',
  },
  'ssr.title.roll.out': {
    ko: 'Roll outs',
    ja: 'ロールアウト',
    en: 'Roll outs',
  },
  'ssr.title.in.diag': {
    ko: 'In dialog step',
    ja: 'ダイアログステップ',
    en: 'In dialog step',
  },
  'ssr.title.term.id': {
    ko: 'Terminal ID',
    ja: 'ターミナルID',
    en: 'Terminal ID',
  },
  'ssr.title.proc.time': {
    ko: 'Processing time',
    ja: '処理時間',
    en: 'Processing time',
  },
  'ssr.title.call.no': {
    ko: 'Call number',
    ja: 'コール番号',
    en: 'Call number',
  },
  'ssr.title.alloc.mem': {
    ko: 'New allocated paging memory',
    ja: '割り当てられた新しいページングメモリ',
    en: 'New allocated paging memory',
  },
  'ssr.title.wait.wp': {
    ko: 'Wait from work process',
    ja: 'ワークプロセスから待機',
    en: 'Wait from work process',
  },
  'ssr.title.cmmn.step': {
    ko: 'Communication step',
    ja: 'コミュニケーションステップ',
    en: 'Communication step',
  },
  'ssr.title.req.app': {
    ko: 'Requested by application',
    ja: 'アプリによるリクエスト',
    en: 'Requested by application',
  },
  'ssr.title.trxn.id': {
    ko: 'Trans.-ID',
    ja: 'Trans.-ID',
    en: 'Trans.-ID',
  },
  'ssr.title.in': {
    ko: 'In',
    ja: 'In',
    en: 'In',
  },
  'ssr.title.prog': {
    ko: 'Program',
    ja: 'プログラム',
    en: 'Program',
  },
  'ssr.title.db.call': {
    ko: 'Database calls',
    ja: 'データベースコール',
    en: 'Database calls',
  },
  'ssr.title.priv.mem': {
    ko: 'Private memory in use',
    ja: '使用中のプライベートメモリ',
    en: 'Private memory in use',
  },
  'ssr.title.load.time': {
    ko: 'Load time',
    ja: 'ロード時間',
    en: 'Load time',
  },
  'ssr.title.conn.id': {
    ko: 'Connection ID',
    ja: '接続ID',
    en: 'Connection ID',
  },
  'ssr.title.calls': {
    ko: 'Calls',
    ja: 'コール',
    en: 'Calls',
  },
  'ssr.title.received.data': {
    ko: 'Received data',
    ja: '受信したデータ',
    en: 'Received data',
  },
  'ssr.title.cua.interf': {
    ko: 'CUA intef.',
    ja: 'CUA intef.',
    en: 'CUA intef.',
  },
  'ssr.title.ext.mem': {
    ko: 'Extended memory in use',
    ja: '使用中の拡張メモリ',
    en: 'Extended memory in use',
  },
  'ssr.title.data.receive.time': {
    ko: 'Data receive time',
    ja: 'データ受信時間',
    en: 'Data receive time',
  },
  'ssr.title.max.ext': {
    ko: 'Max. extended memory used',
    ja: '最大使用された拡張メモリ',
    en: 'Max. extended memory used',
  },
  'ssr.title.ext.pass': {
    ko: 'Extended Passport',
    ja: '拡張されたパスポート',
    en: 'Extended Passport',
  },
  'ssr.title.data.sent': {
    ko: 'Data Sent',
    ja: '送信されたデータ',
    en: 'Data Sent',
  },
  'ssr.title.remote.exec.time': {
    ko: 'Remote exec. time',
    ja: 'リモート実行時間',
    en: 'Remote exec. time',
  },
  'ssr.title.ini.sstm.id': {
    ko: 'Initial system-ID',
    ja: 'イニシャルシステムID',
    en: 'Initial system-ID',
  },
  'ssr.title.ptnr.release': {
    ko: 'Partner Release',
    ja: 'パートナーリリース',
    en: 'Partner Release',
  },
  'ssr.title.commit.time': {
    ko: 'Commit time',
    ja: 'コミット時間',
    en: 'Commit time',
  },
  'ssr.title.caller.user.nm': {
    ko: 'Caller user name',
    ja: 'コーラーユーザー名',
    en: 'Caller user name',
  },
  'ssr.title.func.nm': {
    ko: 'Function name',
    ja: '関数名',
    en: 'Function name',
  },
  'ssr.title.rt': {
    ko: 'Response time',
    ja: '応答時間',
    en: 'Response time',
  },
  'ssr.title.db.proc.time': {
    ko: 'DB Proc. time',
    ja: 'DB処理時間',
    en: 'DB Proc. time',
  },
  'ssr.title.batch.input.que.time': {
    ko: 'Batch-input queue time',
    ja: 'バッチ入力キュー時間',
    en: 'Batch-input queue time',
  },
  'ssr.title.wait': {
    ko: 'Wait',
    ja: '待機',
    en: 'Wait',
  },
  'ssr.title.src.load': {
    ko: 'Sources + Loads',
    ja: 'ソース+ロード',
    en: 'Sources + Loads',
  },
  'ssr.title.fe.round': {
    ko: 'Frontend No. roundtris',
    ja: 'フロントエンドNo. roundtris',
    en: 'Frontend No. roundtris',
  },
  'ssr.title.screen': {
    ko: 'Screen',
    ja: 'スクリーン',
    en: 'Screen',
  },
  'ssr.title.atzn.time': {
    ko: 'Authorization time',
    ja: '認可時間',
    en: 'Authorization time',
  },
  'ssr.title.root.ctxt.id': {
    ko: 'Root Context ID',
    ja: 'ルートコンテキストID',
    en: 'Root Context ID',
  },
  'ssr.title.roll.time': {
    ko: 'Roll time',
    ja: 'ロール時間',
    en: 'Roll time',
  },
  'ssr.title.tot.mem.used': {
    ko: 'Total memory used',
    ja: '使用された総メモリ',
    en: 'Total memory used',
  },
  'ssr.title.idle.time': {
    ko: 'Idle time',
    ja: 'アイドル時間',
    en: 'Idle time',
  },
  'ssr.title.rfc.cpic.time': {
    ko: 'RFC+CPIC time',
    ja: 'RFC + CPIC時間',
    en: 'RFC+CPIC time',
  },
};
